import styled from 'styled-components';
import { StyledContainer } from '../../components/container/style';

export const StyledHeader = styled.header`
  background: #fff;
`

export const StyledLogo = styled.img`
  height: 45px;
`

export const StyledHeaderContainer = styled(StyledContainer)`
  padding: 30px 15px 15px;
  position: relative;
  display: flex;
  justify-content: center;
`
